import { observer } from 'mobx-react';
import { Link, useParams } from 'react-router-dom';
import React from 'react';
import HeaderPage from '@organisms/common/HeaderPage';
import FloatArea from '@molecules/FloatArea';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { useCallback, useEffect } from 'react';
import { useMobxStores } from '@stores/store';

import WithBTSDetail from '@app/components/organisms/devlog/WithBTSDetail';
import { GFH_ENV, isMobileWithOutIpad } from '@helpers/EnvHelper';
import { isEmpty as _isEmpty } from 'lodash';
import { bgmCodes } from '@stores/SettingStore';
import classnames from 'classnames';
import LinkBtn from '@atoms/btn/LinkBtn';
import moment from 'moment';
import BoardDetail from '@organisms/community/BoardDetail';

const BoardDetailPage = () => {
  const { communityStore } = useMobxStores();
  const { newsIdx } = useParams();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const getInitialDetailData = useCallback(
    async function () {
      await communityStore.getNotice(newsIdx, i18n.language);
      return true;
    },
    [communityStore, i18n.language, newsIdx]
  );

  useEffect(() => {
    getInitialDetailData().then(() => {
      if (GFH_ENV === 'prod' || GFH_ENV === 'qa') {
        if (_isEmpty(communityStore.notice)) {
          navigate(`/${i18n.language}/404`);
        }
      }
    });
    //console.log('notice', newsIdx, communityStore.notice);
  }, [getInitialDetailData]);

  return (
    <>
      {newsIdx > 0 && !_isEmpty(communityStore.notice) && (
        <BoardDetail idx={newsIdx} data={communityStore.notice} />
      )}
    </>
  );
};

export default observer(BoardDetailPage);
